Vue.directive('togglenav', {
    // When the bound element is inserted into the DOM...
    bind(el) {
        el.addEventListener('click', function (event) {
            event.preventDefault();
            window.toggleNav(); 
        });
    }
});
